<div class="flex-center">
  <div class="p-relative flex-center">
    @if (loading) {
      <div class="image-loading flex-center">
        <app-spinner [color]="'grey'" [scale]="0.7"></app-spinner>
      </div>
    }
    @if (!loading) {
      <img [src]="dark ? logo + '?dark=true' : logo" alt="" [style.width.px]="size" [style.height.px]="size" [style.border-radius.px]="size / 4">
    }
  </div>
</div>
